import React, { useEffect, useState } from 'react';
import styles from './iframe.module.scss';
import { useIsMobile } from '../../../hooks/utils/useIsMobile';

const Iframe = ({ data }) => {
  const { name, url, width, mobileWidth, height, mobileHeight, anchorId } = data;
  const isMobile = useIsMobile();
  const [dimensions, setDimensions] = useState({});

  useEffect(() => {
    const w = isMobile ? mobileWidth : width;
    const h = isMobile ? mobileHeight : height;
    setDimensions({
      width: `${w || '100'}%`,
      height: h || '500',
    });
  }, [isMobile]);

  return (
    <div id={anchorId} className={styles.container}>
      <iframe
        title={name}
        src={url}
        width={dimensions.width}
        height={dimensions.height}
        seamless="seamless"
        allowFullScreen
        allow="autoplay; clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default Iframe;
